export enum HomeEndPoints {
	home = '/v1/entry-flow/beneficiary/home',
}

export enum BookingFlowEndPoints {
	healthStates = '/v1/booking-flow/health/states',
	healthCities = '/v1/booking-flow/health/cities',
	healthSpecialties = '/v1/booking-flow/health/specialties',
	healthSpecialtiesLocalities = '/v1/booking-flow/health/specialties-localities',
	healthProviders = '/v1/booking-flow/health/providers',
	healthDates = '/v1/booking-flow/health/dates',
	healthAvailableTimes = '/v1/booking-flow/health/available-times',
	healthBookingConfirm = '/v1/booking-flow/health/book',
	healthLocalities = '/v1/booking-flow/health/localities',
	healthProviderLocation = '/v1/booking-flow/health/provider-location',
	healthProviderNames = '/v1/booking-flow/health/get-provider',
}

export enum BookedFlowEndPoints {
	healthBooked = '/v1/booked-flow/health/schedules',
	healthBookedV3 = '/v3/booked-flow/health/schedules',
	healthBookedConfirm = '/v1/booked-flow/health/confirm',
	healthRebooking = '/v1/booked-flow/health/reschedule',
	healthCancel = '/v1/booked-flow/health/cancel',
}

export enum TeaFormFlowEndpoints {
	teaForm = '/v1/links-flow/tea-form',
}
